import { CustomerStatusType } from '../customer/types/customerStatusType';

export interface Integration {
  id: string;
  name: IntegrationConfigName;
  url: string;
  token: string;
  active: boolean;
}

export interface IntegrationBrandConfig {
  clientId?: string;
  clientSecret?: string;
  branchCode?: string;
  username?: string;
  password?: string;
}

export enum IntegrationConfigName {
  INTEGRADOR_TOTVS_MODA = 'INTEGRADOR TOTVS MODA',
  INTEGRADOR_VERUP_CSV = 'INTEGRADOR VERUP CSV',
  INTEGRADOR_LYNX_SERVER = 'INTEGRADOR LYNX SERVER',
  INTEGRADOR_EMILLENNIUM = 'EMILLENNIUM INTEGRATOR',
  INTEGRADOR_HOPE = 'HOPE INTEGRATOR',
  TECEO_BRAND_INTEGRATOR = 'TECEO BRAND INTEGRATOR',
}

export type StatusApprovalDTO = {
  status: CustomerStatusType;
};
